export { c as buttonColor, e as buttonEqualSizes, f as buttonFill, a as buttonShape, b as buttonShapeEqual, d as buttonSize, h as buttonSizes, i as checkboxSize, i as controlSize, j as headingSize, c as iconButtonColor, f as iconButtonFill, b as iconButtonShape, d as iconButtonSize, s as iconSize, l as iconSizes, k as listSize, l as loaderSizes, m as progressSize, v as progressVariant, i as radioSize, i as sliderSize, n as tabSize, o as textSize } from '../../dist/text-76e6f14c.esm.js';
import _pick from 'ramda/src/pick';
import _map from 'ramda/src/map';
import capsizesJson from '@hover/tokens-typography/assets/capsizes.bauhaus.json';
import * as tokens$1 from '@hover/tokens-typography/bauhaus';
export { p as borderPreset, a as borderPresets, b as borderWidths, c as breakpoints, h as colorHues, n as colorHuesNeutral, d as colorPalettes, s as colorSchemes, e as colorSchemesBrand, f as colorSchemesNeutral, g as colorSchemesProduct, m as motion, i as shadows } from '../../dist/shadows-2f16f0de.esm.js';
import '@hover/tokens-border';
export { a as sizes, s as space } from '../../dist/space-d858ce6e.esm.js';
import '@hover/tokens-typography';
export { g as colors, r as radii } from '../../dist/radii-300ca920.esm.js';
import '@hover/utilities';
import '@hover/tokens-depth';
import '@hover/tokens-size';
import '@hover/tokens-size/next';
import '@hover/tokens-space/next';
import '@hover/tokens-typography/next';
import * as tokens from '@hover/tokens-color';
export { tokens as colorTokens };
import '../../dist/unsupportedIterableToArray-d4b21e24.esm.js';
import '@hover/tokens-space';
import '@hover/tokens-typography/assets/capsizes.json';
import '@hover/tokens-device';
import '@hover/tokens-motion';
import '@hover/tokens-typography/assets/capsizes.next.json';
import '@hover/tokens-color/next';
import '@hover/tokens-border/next';

var presets$1 = {
  100: {
    fontSize: tokens$1.heading100Size,
    fontWeight: tokens$1.heading100Weight,
    lineHeight: tokens$1.heading100Height,
    marginBottom: tokens$1.heading100Margin,
    letterSpacing: tokens$1.heading100LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  200: {
    fontSize: tokens$1.heading200Size,
    fontWeight: tokens$1.heading200Weight,
    lineHeight: tokens$1.heading200Height,
    marginBottom: tokens$1.heading200Margin,
    letterSpacing: tokens$1.heading200LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  300: {
    fontWeight: tokens$1.heading300Weight,
    fontSize: tokens$1.heading300Size,
    lineHeight: tokens$1.heading300Height,
    marginBottom: tokens$1.heading300Margin,
    letterSpacing: tokens$1.heading300LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  400: {
    fontWeight: tokens$1.heading400Weight,
    fontSize: tokens$1.heading400Size,
    lineHeight: tokens$1.heading400Height,
    marginBottom: tokens$1.heading400Margin,
    letterSpacing: tokens$1.heading400LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  500: {
    fontWeight: tokens$1.heading500Weight,
    fontSize: tokens$1.heading500Size,
    lineHeight: tokens$1.heading500Height,
    marginBottom: tokens$1.heading500Margin,
    letterSpacing: tokens$1.heading500LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  600: {
    fontWeight: tokens$1.heading600Weight,
    fontSize: tokens$1.heading600Size,
    lineHeight: tokens$1.heading600Height,
    marginBottom: tokens$1.heading600Margin,
    letterSpacing: tokens$1.heading600LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  /**
   * @deprecated use 600
   */
  650: {
    fontWeight: tokens$1.heading650Weight,
    fontSize: tokens$1.heading650Size,
    lineHeight: tokens$1.heading650Height,
    marginBottom: tokens$1.heading650Margin,
    letterSpacing: tokens$1.heading650LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  700: {
    fontWeight: tokens$1.heading700Weight,
    fontSize: tokens$1.heading700Size,
    lineHeight: tokens$1.heading700Height,
    marginBottom: tokens$1.heading700Margin,
    letterSpacing: tokens$1.heading700LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  800: {
    fontWeight: tokens$1.heading800Weight,
    fontSize: tokens$1.heading800Size,
    lineHeight: tokens$1.heading800Height,
    marginBottom: tokens$1.heading800Margin,
    letterSpacing: tokens$1.heading800LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  },
  900: {
    fontWeight: tokens$1.heading900Weight,
    fontSize: tokens$1.heading900Size,
    lineHeight: tokens$1.heading900Height,
    marginBottom: tokens$1.heading900Margin,
    letterSpacing: tokens$1.heading900LetterSpacing,
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family
  }
};
var aliases$1 = {
  xs: 100,
  small: 200,
  medium: 400,
  large: 600,
  xl: 700,
  xxl: 900
};
var sizes$1 = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight', 'letterSpacing']), presets$1);
var capsizes$1 = capsizesJson.heading;

var presets = {
  200: {
    fontSize: tokens$1.body200Size,
    fontWeight: tokens$1.body200Weight,
    lineHeight: tokens$1.body200Height
  },
  300: {
    fontWeight: tokens$1.body300Weight,
    fontSize: tokens$1.body300Size,
    lineHeight: tokens$1.body300Height
  },
  400: {
    fontWeight: tokens$1.body400Weight,
    fontSize: tokens$1.body400Size,
    lineHeight: tokens$1.body400Height
  },
  500: {
    fontWeight: tokens$1.body500Weight,
    fontSize: tokens$1.body500Size,
    lineHeight: tokens$1.body500Height
  },
  600: {
    fontWeight: tokens$1.body600Weight,
    fontSize: tokens$1.body600Size,
    lineHeight: tokens$1.body600Height
  }
};
var aliases = {
  footnote: 200,
  small: 300,
  medium: 400
};
var sizes = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight']), presets);
var capsizes = capsizesJson.body;

var typography = {
  fonts: {
    body: tokens$1.familyBody,
    brand: tokens$1.familyBrand,
    code: tokens$1.familyCode,
    display: tokens$1.familyDisplay
  },
  lineHeights: {
    50: tokens$1.height50,
    100: tokens$1.height100,
    200: tokens$1.height200,
    300: tokens$1.height300,
    400: tokens$1.height400,
    500: tokens$1.height500,
    600: tokens$1.height600,
    700: tokens$1.height700,
    800: tokens$1.height800,
    900: tokens$1.height900,
    1000: tokens$1.height1000
  },
  fontWeights: {
    100: tokens$1.weight100,
    300: tokens$1.weight300,
    400: tokens$1.weight400,
    500: tokens$1.weight500,
    600: tokens$1.weight600,
    700: tokens$1.weight700,
    body: tokens$1.weightBody,
    bodyBold: tokens$1.weightBodyBold,
    bodySemiBold: tokens$1.weightBodySemiBold,
    bodyMedium: tokens$1.weightBodyMedium,
    display: tokens$1.weightDisplay,
    heading: tokens$1.weightHeading,
    headingLight: tokens$1.weightHeadingLight
  },
  fontSizes: {
    50: tokens$1.size50,
    100: tokens$1.size100,
    200: tokens$1.size200,
    300: tokens$1.size300,
    400: tokens$1.size400,
    500: tokens$1.size500,
    600: tokens$1.size600,
    700: tokens$1.size700,
    800: tokens$1.size800,
    900: tokens$1.size900,
    1000: tokens$1.size1000,
    base: tokens$1.sizeBase
  },
  letterSpacings: {
    100: tokens$1.spacing100,
    200: tokens$1.spacing200,
    300: tokens$1.spacing300,
    400: tokens$1.spacing400,
    500: tokens$1.spacing500,
    600: tokens$1.spacing600,
    700: tokens$1.spacing700,
    800: tokens$1.spacing800,
    900: tokens$1.spacing900,
    1000: tokens$1.spacing1000,
    base: tokens$1.spacingBase
  }
};

export { aliases$1 as headingAliases, capsizes$1 as headingCapsizes, presets$1 as headingPresets, sizes$1 as headingSizes, aliases as textAliases, capsizes as textCapsizes, presets as textPresets, sizes as textSizes, typography };
